import { ErrorReport, ErrorReportDto } from '.';

export class ErrorReportAdapter {
  /**
   * Stringify a report for data transfer.
   *
   * By default `JSON.stringify(report)` isn't enough to also copy all of the error's content.
   *
   * @param report The report to stringify
   * @returns A deep stringification of the object
   */
  public stringify(report: ErrorReport): string {
    return JSON.stringify(report, Object.getOwnPropertyNames(report));
  }

  /**
   * Convert a report to a DTO—i.e. just a simple object and no lnoger an ErrorReport instance.
   *
   * @param report The report to convert to a DTO
   * @returns An object that's a deep clone DTO of the report
   */
  public toDto(report: ErrorReport): ErrorReportDto {
    const str = this.stringify(report);
    return JSON.parse(str);
  }

  /**
   * Convert an entire list of reports to string.
   *
   * @param reports The report list to stringify
   * @returns The stringified list of reports for data transfer
   */
  public stringifyList(reports: ErrorReport[]): string {
    const dtos = reports.map(r => this.toDto(r));
    return JSON.stringify(dtos);
  }
}
